import { createSelector } from '@ngrx/store';
import { AppState } from '../app.reducer';

export const selectDeviceState = (state: AppState) =>
  state.device;


export const selectCurrentDevice = createSelector(
  selectDeviceState,
  (state) => state.currentDevice
);
export const selectCurrentDeviceModel = createSelector(
  selectDeviceState,
  (state) => state.currentDeviceModel
);
export const selectCurrentDeviceInfo = createSelector(
  selectDeviceState,
  (state) => state.currentDeviceInfo
);
export const selectCurrentDeviceStatus = createSelector(
  selectDeviceState,
  (state) => state.currentDeviceStatus
);
export const selectCurrentDeviceCommands = createSelector(
  selectDeviceState,
  (state) => state.currentDeviceCommands
);
export const selectCurrentDeviceSettingsCategories = createSelector(
  selectDeviceState,
  (state) => state.currentDeviceSettingsCategories
);
export const selectGateStates = createSelector(
  selectDeviceState,
  (state) => state.gateStates
);
export const selectDevicesStatus = createSelector(
  selectDeviceState,
  (state) => state.devicesStatus
);
export const selectCurrentDeviceLoading = createSelector(
  selectDeviceState,
  (state) => state.currentDeviceLoading
);
export const selectCurrentDeviceSuccess = createSelector(
  selectDeviceState,
  (state) => state.currentDeviceSuccess
);
export const selectMtmaModules = createSelector(
  selectDeviceState,
  (state) => state.mtmaModules
);
export const selectMtmaChanges = createSelector(
  selectDeviceState,
  (state) => state.mtmaChanges
);
export const selectMtmaActiveTask = createSelector(
  selectDeviceState,
  (state) => state.mtmaActiveTask
);
export const selectCurrentDeviceFeatures = createSelector(
  selectDeviceState,
  (state) => state.currentDeviceFeatures
);
export const selectMtmaContacts = createSelector(
  selectDeviceState,
  (state) => state.mtmaContacts
);
export const selectMtmaContactsPagination = createSelector(
  selectDeviceState,
  (state) => state.mtmaContactsPagination
);
export const selectMtmaContactsMaxData = createSelector(
  selectDeviceState,
  (state) => state.mtmaContactsMaxData
);
export const selectMtmaCommandAutomation = createSelector(
  selectDeviceState,
  (state) => state.mtmaCommandAutomation
);
export const selectMtmaActions = createSelector(
  selectDeviceState,
  (state) => state.mtmaActions
);
export const selectMtmaContactModify = createSelector(
  selectDeviceState,
  (state) => state.mtmaContactModify
);
export const selectInitializing = createSelector(
  selectDeviceState,
  (state) => state.initializing
);
export const selectCurrentDeviceSignalData = createSelector(
  selectDeviceState,
  (state) => state.currentDeviceSignalData
);
export const selectReadingSignal = createSelector(
  selectDeviceState,
  (state) => state.readingSignal
);
export const selectCurrentDatetimeDeviceData = createSelector(
  selectDeviceState,
  (state) => state.currentDatetimeDeviceData
);
export const selectReadingDatetimeDevice = createSelector(
  selectDeviceState,
  (state) => state.readingDatetimeDevice
);
export const selectBoardUsersTaskRunning = createSelector(
  selectDeviceState,
  (state) => state.boardUsersTaskRunning
);
export const selectBoardUsersLoading = createSelector(
  selectDeviceState,
  (state) => state.boardUsersLoading
);
export const selectCurrentDeviceBoardUsers = createSelector(
  selectDeviceState,
  (state) => state.currentDeviceBoardUsers
);
export const selectCurrentDeviceBoardUsersInfo = createSelector(
  selectDeviceState,
  (state) => state.currentDeviceBoardUsersInfo
);
export const selectBoardUsersItemsPagination = createSelector(
  selectDeviceState,
  (state) => state.boardUsersItemsPagination
)
export const selectInputEditing = createSelector(
  selectDeviceState,
  (state) => state.inputEditing
);
export const selectInputEdited = createSelector(
  selectDeviceState,
  (state) => state.inputEdited
);
export const selectOutputEditing = createSelector(
  selectDeviceState,
  (state) => state.outputEditing
);
export const selectOutputEdited = createSelector(
  selectDeviceState,
  (state) => state.outputEdited
);
export const selectCurrentDeviceRemoteClients = createSelector(
  selectDeviceState,
  (state) => state.currentDeviceRemoteClients
);
export const selectCurrentDeviceFinalUserRemoteClients = createSelector(
  selectDeviceState,
  (state) => state.currentDeviceFinalUserRemoteClients
);
export const selectCurrentDeviceFinalUsers = createSelector(
  selectDeviceState,
  (state) => state.currentDeviceFinalUsers
);
export const selectShared = createSelector(
  selectDeviceState,
  (state) => state.shared
);
export const selectRemoteClientDeleted = createSelector(
  selectDeviceState,
  (state) => state.remoteClientDeleted
);
export const selectCurrentDeviceProfiles = createSelector(
  selectDeviceState,
  (state) => state.currentDeviceProfiles
);
export const selectCurrentDeviceFinalUserProfiles = createSelector(
  selectDeviceState,
  (state) => state.currentDeviceFinalUserProfiles
);
export const selectCurrentDeviceSafetyInputs = createSelector(
  selectDeviceState,
  (state) => state.currentDeviceSafetyInputs
);
export const selectSafetyInputsLoading = createSelector(
  selectDeviceState,
  (state) => state.safetyInputsLoading
);
export const selectSettingsLoading = createSelector(
  selectDeviceState,
  (state) => state.settingsLoading
);
export const selectDeviceEdited = createSelector(
  selectDeviceState,
  (state) => state.deviceEdited
);
export const selectDeviceEditing = createSelector(
  selectDeviceState,
  (state) => state.deviceEditing
);
export const selectBoardUserAdding = createSelector(
  selectDeviceState,
  (state) => state.boardUserAdding
);
export const selectBoardUserEditing = createSelector(
  selectDeviceState,
  (state) => state.boardUserEditing
);
export const selectBoardUserAdded = createSelector(
  selectDeviceState,
  (state) => state.boardUserAdded
);
export const selectBoardUserEdited = createSelector(
  selectDeviceState,
  (state) => state.boardUserEdited
);
export const selectCommandsEdited = createSelector(
  selectDeviceState,
  (state) => state.commandsEdited
);
export const selectDeviceModels = createSelector(
  selectDeviceState,
  (state) => state.deviceModels
);
export const selectAddingDevice = createSelector(
  selectDeviceState,
  (state) => state.addingDevice
);
export const selectAddedDeviceId = createSelector(
  selectDeviceState,
  (state) => state.addedDeviceId
);
export const selectBoardUserAcquiring = createSelector(
  selectDeviceState,
  (state) => state.boardUserAcquiring
);
export const selectBoardUserAcquired = createSelector(
  selectDeviceState,
  (state) => state.boardUserAcquired
);
export const selectMtmaUnits = createSelector(
  selectDeviceState,
  (state) => state.mtmaUnits
);
export const selectMtmaUnitsPagination = createSelector(
  selectDeviceState,
  (state) => state.mtmaUnitsPagination
);
export const selectMtmaUnitsMaxData = createSelector(
  selectDeviceState,
  (state) => state.mtmaUnitsMaxData
);
export const selectMtmaUnitModify = createSelector(
  selectDeviceState,
  (state) => state.mtmaUnitModify
);
export const selectMtmaDtmfs = createSelector(
  selectDeviceState,
  (state) => state.mtmaDtmfs
);
export const selectMtmaDtmfsPagination = createSelector(
  selectDeviceState,
  (state) => state.mtmaDtmfsPagination
);
export const selectMtmaDtmfsMaxData = createSelector(
  selectDeviceState,
  (state) => state.mtmaDtmfsMaxData
);
export const selectMtmaDtmfModify = createSelector(
  selectDeviceState,
  (state) => state.mtmaDtmfModify
);
export const selectMtmaRulesAll = createSelector(
  selectDeviceState,
  (state) => state.mtmaRulesAll
);
export const selectMtmaRuleModify = createSelector(
  selectDeviceState,
  (state) => state.mtmaRuleModify
);
// Mtma Keypads
export const selectMtmaKeypads = createSelector(
  selectDeviceState,
  (state) => state.mtmaKeypads
);
export const selectMtmaKeypadsPagination = createSelector(
  selectDeviceState,
  (state) => state.mtmaKeypadsPagination
);
export const selectMtmaKeypadsMaxData = createSelector(
  selectDeviceState,
  (state) => state.mtmaKeypadsMaxData
);
export const selectMtmaKeypadsInvalid = createSelector(
  selectDeviceState,
  (state) => state.mtmaKeypadsInvalid
);
export const selectMtmaKeypadModify = createSelector(
  selectDeviceState,
  (state) => state.mtmaKeypadModify
);
export const selectMtmaTags = createSelector(
  selectDeviceState,
  (state) => state.mtmaTags
);
export const selectMtmaTagsPagination = createSelector(
  selectDeviceState,
  (state) => state.mtmaTagsPagination
);
export const selectMtmaTagsMaxData = createSelector(
  selectDeviceState,
  (state) => state.mtmaTagsMaxData
);
export const selectMtmaTagModify = createSelector(
  selectDeviceState,
  (state) => state.mtmaTagModify
);
export const selecMtmaModules = createSelector(
  selectDeviceState,
  (state) => state.mtmaModules
);
export const selectFirmwareUpdate = createSelector(
  selectDeviceState,
  (state) => state.firmwareUpdate
);
export const selecMtmaSettingsModules = createSelector(
  selectDeviceState,
  (state) => state.mtmaSettingsModules
);
export const selectConnectedAutomationsCommands = createSelector(
  selectDeviceState,
  (state) => state.connectedAutomationsCommands
);
export const selectRbeAccessLog = createSelector(
  selectDeviceState,
  (state) => state.rbeAccessLog
);
export const selectRbeAccessLogExport = createSelector(
  selectDeviceState,
  (state) => state.rbeAccessLogExport
);
export const selectRbeAccessLogPagination = createSelector(
  selectDeviceState,
  (state) => state.rbeAccessLogPagination
);
export const selectMtmaEditModule = createSelector(
  selectDeviceState,
  (state) => state.mtmaEditModule
);
export const selectDeviceTimerModify = createSelector(
  selectDeviceState,
  (state) => state.deviceTimerModify
);
export const selectDeviceSpecialDayModify = createSelector(
  selectDeviceState,
  (state) => state.deviceSpecialDayModify
);
export const selectDeviceSpecialDayInfo = createSelector(
  selectDeviceState,
  (state) => state.deviceSpecialDayInfo
);
export const selectDeviceSpecialDays = createSelector(
  selectDeviceState,
  (state) => state.deviceSpecialDays
);
export const selectDeviceTimerInfo = createSelector(
  selectDeviceState,
  (state) => state.deviceTimerInfo
);
export const selectDeviceTimers = createSelector(
  selectDeviceState,
  (state) => state.deviceTimers
);
export const selectAutomationConnectedNameEdit = createSelector(
  selectDeviceState,
  (state) => state.automationConnectedNameEdit
);
export const selectIsSupportTimers = createSelector(
  selectDeviceState,
  (state) => state.isSupportTimers
);
export const selectStateDeviceByCommandId = createSelector(
  selectDeviceState,
  (state) => state.deviceState
);
export const selectStateDeviceByCommandId4 = createSelector(
  selectDeviceState,
  (state) => state.deviceState4
);
export const selectCallUnitLog = createSelector(
  selectDeviceState,
  (state) => state.callUnitLog
);
export const selectCallUnitLogPagination = createSelector(
  selectDeviceState,
  (state) => state.callUnitLogPagination
);
export const selectMtmaDiagnosticsLog = createSelector(
  selectDeviceState,
  (state) => state.mtmaDiagnosticsLog
);
export const selectMtmaDiagnosticsLogPagination = createSelector(
  selectDeviceState,
  (state) => state.mtmaDiagnosticsLogPagination
);
export const selectMtmaDiagnosticsLogAction = createSelector(
  selectDeviceState,
  (state) => state.mtmaDiagnosticsLogAction
);
export const selectMtmaFwAutoUpdateTimeslot = createSelector(
  selectDeviceState,
  (state) => state.mtmaFwAutoUpdateTimeslot
);
export const selectMtmaFwAutoUpdateTimeslotModify = createSelector(
  selectDeviceState,
  (state) => state.mtmaFwAutoUpdateTimeslotModify
);
export const selectAccessLog = createSelector(
  selectDeviceState,
  (state) => state.accessLog
);
export const selectAccessLogExport = createSelector(
  selectDeviceState,
  (state) => state.accessLogExport
);
export const selectAccessLogPagination = createSelector(
  selectDeviceState,
  (state) => state.accessLogPagination
);
export const selectCallUnitLogExport = createSelector(
  selectDeviceState,
  (state) => state.callUnitLogExport
);
export const selectPasswordValid = createSelector(
  selectDeviceState,
  (state) => state.passwordValid
);
export const selectPasswordChange = createSelector(
  selectDeviceState,
  (state) => state.passwordChange
);
export const selectPasswordRequest = createSelector(
  selectDeviceState,
  (state) => state.passwordRequest
);
export const selectPasswordEnabled = createSelector(
  selectDeviceState,
  (state) => state.passwordEnabled
);
export const selectSharing = createSelector(
  selectDeviceState,
  (state) => state.sharing
);
//-----------Control Access
// Groups
export const selectGroups = createSelector(
  selectDeviceState,
  (state) => state.groups
);
export const selectGroupsAll = createSelector(
  selectDeviceState,
  (state) => state.groupsAll
);
export const selectGroupsPagination = createSelector(
  selectDeviceState,
  (state) => state.groupsPagination
);
export const selectGroupsMaxData = createSelector(
  selectDeviceState,
  (state) => state.groupsMaxData
);
export const selectGroupModify = createSelector(
  selectDeviceState,
  (state) => state.groupModify
);
export const selectGroupModifing = createSelector(
  selectDeviceState,
  (state) => state.groupModifing
);
// WeeklySchedules
export const selectWeeklySchedules = createSelector(
  selectDeviceState,
  (state) => state.weeklySchedules
);
export const selectWeeklySchedulesPagination = createSelector(
  selectDeviceState,
  (state) => state.weeklySchedulesPagination
);
export const selectWeeklySchedulesMaxData = createSelector(
  selectDeviceState,
  (state) => state.weeklySchedulesMaxData
);
export const selectWeeklyScheduleModify = createSelector(
  selectDeviceState,
  (state) => state.weeklyScheduleModify
);
export const selectWeeklyScheduleModifing = createSelector(
  selectDeviceState,
  (state) => state.weeklyScheduleModifing
);
export const selectWeeklySchedulesAll = createSelector(
  selectDeviceState,
  (state) => state.weeklySchedulesAll
);
// SpecialPlannings
export const selectSpecialPlannings = createSelector(
  selectDeviceState,
  (state) => state.specialPlannings
);
export const selectSpecialPlanningsPagination = createSelector(
  selectDeviceState,
  (state) => state.specialPlanningsPagination
);
export const selectSpecialPlanningsMaxData = createSelector(
  selectDeviceState,
  (state) => state.specialPlanningsMaxData
);
export const selectSpecialPlanningModify = createSelector(
  selectDeviceState,
  (state) => state.specialPlanningModify
);
export const selectSpecialPlanningModifing = createSelector(
  selectDeviceState,
  (state) => state.specialPlanningModifing
);
export const selectSpecialPlanningsAll = createSelector(
  selectDeviceState,
  (state) => state.specialPlanningsAll
);
export const selectRemoteClientDeleting = createSelector(
  selectDeviceState,
  (state) => state.remoteClientDeleting
);
export const selectRemoteClientLockingUnlocking = createSelector(
  selectDeviceState,
  (state) => state.remoteClientLockingUnlocking
);
export const selectRemoteClientLockedUnlocked = createSelector(
  selectDeviceState,
  (state) => state.remoteClientLockedUnlocked
);
//-----------Control Access
export const selectCurrentDeviceSettingsCategoriesPaging = createSelector(
  selectDeviceState,
  (state) => state.currentDeviceSettingsCategoriesPaging
);
export const selectCurrentDeviceSettingsCategoriesPagingLoading = createSelector(
  selectDeviceState,
  (state) => state.currentDeviceSettingsCategoriesPagingLoading
);
export const selectCurrentDeviceSettingsCategoriesPagingError = createSelector(
  selectDeviceState,
  (state) => state.currentDeviceSettingsCategoriesPagingError
);
export const selectNewDeviceModels = createSelector(
  selectDeviceState,
  (state) => state.newDeviceModels
);
//-----------Control Access Mtma
// Groups
export const selectMtmaGroups = createSelector(
  selectDeviceState,
  (state) => state.mtmaGroups
);
export const selectMtmaGroupsAll = createSelector(
  selectDeviceState,
  (state) => state.mtmaGroupsAll
);
export const selectMtmaGroupsPagination = createSelector(
  selectDeviceState,
  (state) => state.mtmaGroupsPagination
);
export const selectMtmaGroupsMaxData = createSelector(
  selectDeviceState,
  (state) => state.mtmaGroupsMaxData
);
export const selectMtmaGroupModify = createSelector(
  selectDeviceState,
  (state) => state.mtmaGroupModify
);
// WeeklySchedules
export const selectMtmaWeeklySchedules = createSelector(
  selectDeviceState,
  (state) => state.mtmaWeeklySchedules
);
export const selectMtmaWeeklySchedulesPagination = createSelector(
  selectDeviceState,
  (state) => state.mtmaWeeklySchedulesPagination
);
export const selectMtmaWeeklySchedulesMaxData = createSelector(
  selectDeviceState,
  (state) => state.mtmaWeeklySchedulesMaxData
);
export const selectMtmaWeeklyScheduleModify = createSelector(
  selectDeviceState,
  (state) => state.mtmaWeeklyScheduleModify
);
export const selectMtmaWeeklySchedulesAll = createSelector(
  selectDeviceState,
  (state) => state.mtmaWeeklySchedulesAll
);
// WeeklySchedules
export const selectMtmaSpecialPlannings = createSelector(
  selectDeviceState,
  (state) => state.mtmaSpecialPlannings
);
export const selectMtmaSpecialPlanningsPagination = createSelector(
  selectDeviceState,
  (state) => state.mtmaSpecialPlanningsPagination
);
export const selectMtmaSpecialPlanningsMaxData = createSelector(
  selectDeviceState,
  (state) => state.mtmaSpecialPlanningsMaxData
);
export const selectMtmaSpecialPlanningModify = createSelector(
  selectDeviceState,
  (state) => state.mtmaSpecialPlanningModify
);
export const selectMtmaSpecialPlanningsAll = createSelector(
  selectDeviceState,
  (state) => state.mtmaSpecialPlanningsAll
);
//-----------Control Access Mtma
export const selectSettingsSaved = createSelector(
  selectDeviceState,
  (state) => state.settingsSaved
);
export const selectAcRbeSyncing = createSelector(
  selectDeviceState,
  (state) => state.acRbeSyncing
);
export const selectAcRbeSynced = createSelector(
  selectDeviceState,
  (state) => state.acRbeSynced
);
export const selectMtmaCloneModify = createSelector(
  selectDeviceState,
  (state) => state.mtmaCloneModify
);
export const selectCloneMtmaRunning = createSelector(
  selectDeviceState,
  (state) => state.cloneMtmaRunning
);
export const selectAutomationsFirmwaresList = createSelector(
  selectDeviceState,
  (state) => state.automationsFirmwaresList
);
export const selectFwVersion = createSelector(
  selectDeviceState,
  (state) => state.fwVersion
);
export const selectMotorBoardRxVersion = createSelector(
  selectDeviceState,
  (state) => state.motorBoardRxVersion
);
export const selectHwVersion = createSelector(
  selectDeviceState,
  (state) => state.hwVersion
);
export const selectfwUpdateStart = createSelector(
  selectDeviceState,
  (state) => state.fwUpdateStart
);
export const selectUpdatedDeviceAutomationRtc = createSelector(
  selectDeviceState,
  (state) => state.updatedDeviceAutomationRtc
);
export const selectNewDeviceState0 = createSelector(
  selectDeviceState,
  (state) => state.newDeviceState0
);
export const selectErrorDuplicateCrp = createSelector(
  selectDeviceState,
  (state) => state.errorDuplicateCrp
);
export const selectBoardUserDeleted = createSelector(
  selectDeviceState,
  (state) => state.boardUserDeleted
);
export const selectBoardUsersDeleted = createSelector(
  selectDeviceState,
  (state) => state.boardUsersDeleted
);
export const selectAcquiredBoardUser = createSelector(
  selectDeviceState,
  (state) => state.acquiredBoardUser
);
export const selectAutomationAlias = createSelector(
  selectDeviceState,
  (state) => state.automationAlias
);
export const selectAutomationAliasEditing = createSelector(
  selectDeviceState,
  (state) => state.automationAliasEditing
);
export const selectAutomationAliasEdited = createSelector(
  selectDeviceState,
  (state) => state.automationAliasEdited
);
export const selectAutomationsText = createSelector(
  selectDeviceState,
  (state) => state.automationsText
);
export const selectMtmaPermissions = createSelector(
  selectDeviceState,
  (state) => state.mtmaPermissions
);
export const selectMtmaPermissionsPagination = createSelector(
  selectDeviceState,
  (state) => state.mtmaPermissionsPagination
);
export const selectMtmaPermissionsMaxData = createSelector(
  selectDeviceState,
  (state) => state.mtmaPermissionsMaxData
);
export const selectNeedResync = createSelector(
  selectDeviceState,
  (state) => state.needResync
);
export const selectLoadingEdit = createSelector(
  selectDeviceState,
  (state) => state.loadingEdit
);
export const selectLoadingMtmaGroupsAll = createSelector(
  selectDeviceState,
  (state) => state.loadingMtmaGroupsAll
);
export const selectDeviceInfoGatewayById = createSelector(
  selectDeviceState,
  (state) => state.deviceInfoGatewayById
);
export const selectMtmaExportData = createSelector(
  selectDeviceState,
  (state) => state.mtmaExportData
);
